import { useState } from 'react'

import { DSButton, DSCol, DSRow, DSText } from '@vr/ds-react'

import { Content, Drawer } from './styles'
import ModalRemove from '@/compositions/modal-remove'
import ModalError from '@/components/modal-error'
import { useGeneralContext } from '@/contexts/general.context'
import { useDownloadPost } from '@/hooks/use-download-post'
import { downloadFile } from '@/utils/download-file'

export const Actions = ({
  open = true,
  onClose = () => {},
  onRequestLogistics = () => {},
  selectedItems,
  operator
}: {
  open?: boolean
  onClose?: () => void
  onRequestLogistics?: () => void
  selectedItems: { id: string }[]
  operator: any
}) => {
  const [modalError, setModalError] = useState<boolean>(false)
  const [showModalRemove, setShowModalRemove] = useState<boolean>(false)
  const { triggerUnitListRefetch } = useGeneralContext()
  const { downloadPost } = useDownloadPost()

  const total = selectedItems.length
  const itemText = total > 1 ? 'itens' : 'item'
  const selectText = total > 1 ? 'selecionados' : 'selecionado'

  const handleExportExcel = () => {
    const ids = selectedItems.map(item => item.id)
    downloadPost({ idPedidoList: ids })
      .then(response => {
        if (response?.sucesso) {
          downloadFile(
            response.conteudo,
            `logistica-${operator?.idOperadora}.xlsx`,
            'base64'
          )
        } else {
          setModalError(true)
        }
      })
      .catch(error => {
        console.error('Erro ao exportar Excel:', error)
        setModalError(true)
      })
  }

  return (
    <>
      <Drawer
        open={open}
        direction='bottom'
        variant='narrow'
        onClose={onClose}
        title='O que deseja fazer?'
      >
        <Content>
          <DSRow wrap='wrap' align='center'>
            <DSCol xs={12} lg={4} gap={4}>
              <strong>
                {total} {itemText}
              </strong>{' '}
              {selectText}
            </DSCol>
            <DSCol
              xs={12}
              lg={8}
              gap={4}
              direction='row'
              style={{ display: 'flex' }}
              justify='end'
            >
              <DSButton
                variant='ghost'
                outlined
                onClick={() => {
                  onClose()
                  setShowModalRemove(true)
                }}
              >
                Remover
              </DSButton>
              <DSButton
                variant='ghost'
                outlined
                onClick={() => {
                  onClose()
                  handleExportExcel()
                }}
              >
                Exportar logística em Excel
              </DSButton>
              <DSButton
                onClick={() => {
                  onClose()
                  onRequestLogistics()
                }}
              >
                Solicitar logística
              </DSButton>
            </DSCol>
          </DSRow>
        </Content>
      </Drawer>

      {showModalRemove && (
        <ModalRemove
          ids={selectedItems.map(item => item.id)}
          onClose={() => setShowModalRemove(false)}
          onSuccess={triggerUnitListRefetch}
        />
      )}
      <ModalError
        isOpen={modalError}
        title='Erro ao baixar arquivo'
        onClose={() => setModalError(false)}
      >
        <DSText>
          Ocorreu um erro ao baixar o arquivo de logística. Por favor, tente
          novamente mais tarde.
        </DSText>
      </ModalError>
    </>
  )
}
